

import { createContext, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const AuthContext = createContext({
  auth: {},
  setAuth: () => {},
  authChecked: false,
  setAuthChecked: () => {},
});


export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                const data = error?.response?.data;
                if (
                    data?.error === "SESSION_REVOKED" ||
                    (error?.response?.status === 403 &&
                        typeof data?.message === "string" &&
                        data.message.toLowerCase().includes("logged out on another device"))
                ) {
                    setAuth({});
                    toast.info(
                        data?.message ||
                            "You were signed out because this account is in use on other devices.",
                        { toastId: "session-revoked" },
                    );
                }
                return Promise.reject(error);
            },
        );

        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, []);

    return (
        <AuthContext.Provider value={{ auth, setAuth, authChecked, setAuthChecked }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
